import React, {memo, useState} from 'react';
import {Node} from "rete-react-render-plugin";
import Title from "./components/Title";
import {NODE_LABEL_DEFAULT_COLOR, SEQUENCE_NODE_WIDTH} from "../stylingConstants";
import SelectLabelDialog from "./components/SelectLabelDialog";
import DefaultSequenceVideo from "./components/DefaultSequenceVideo";
import {validate as uuidValidate} from "uuid";
import {DefaultSequenceComponent} from "../components";
import {
  NodeContainer,
  HeaderContainer,
  NameContainer,
  NameText,
  StyledIconButton,
  StyledIcon
} from './DefaultSequenceNode.styles';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export class DefaultSequenceNode extends Node {
    render() {
        return <DefaultSequence {...this.props} {...this.state} />
    }
}

const DefaultSequence = memo((props) => {
    const {editor, node, bindControl, controls, selected} = props;
    const [isCollapsed, setIsCollapsed] = useState(node.isCollapsed ?? false);
    const [labelColor, setLabelColor] = useState(node.labelColor ?? null);
    const [showLabelPopup, setShowLabelPopup] = useState(false);
    let videoComponents = {titleControl: null, controls: []};
    if (controls !== undefined) {
        controls.forEach(control => {
            const controlKey = control.key.split('_');
            if (!uuidValidate(controlKey[0])) {
                throw new Error('control key format is not valid!');
            }
            switch(controlKey[1]) {
                case DefaultSequenceComponent.VIDEO_CHILD_COMPONENT_KEY:
                    if (controlKey[2] === DefaultSequenceComponent.NESTED_NODE_TITLE_KEY) {
                        videoComponents.titleControl = control;
                        break;
                    }
                    videoComponents.controls.push(control);
                    break;
                default:
                    console.error(`Component '${controlKey[1]}' does not have 'Control' handling!`);
                    break;
            }
        });
    }
    const showLabelPopupOnClick = (editor, node) => {
        setShowLabelPopup(true);
    }
    const hideLabelPopupOnClick = () => {
        setShowLabelPopup(false);
    }
    const onLabelColorChange = (newColor) => {
        node.labelColor = newColor;
        setLabelColor(newColor);
    }
    const onExpandCollapseClick = (editor, node) => {
        const collapse = !isCollapsed;
        node.isCollapsed = collapse;
        setIsCollapsed(collapse);
    }
    return (
        <NodeContainer selected={selected}>
            <HeaderContainer labelColor={labelColor}>
                <NameContainer>
                    <NameText>
                        {node.name}
                    </NameText>
                </NameContainer>
                <StyledIconButton onClick={() => showLabelPopupOnClick(editor, node)}>
                    <StyledIcon as={PaletteOutlinedIcon} />
                </StyledIconButton>
                <StyledIconButton onClick={() => onExpandCollapseClick(editor, node)}>
                    {isCollapsed ? (
                        <StyledIcon as={ExpandMoreIcon} />
                    ) : (
                        <StyledIcon as={ExpandLessIcon} />
                    )}
                </StyledIconButton>
            </HeaderContainer>
            {showLabelPopup &&
                <SelectLabelDialog
                    onChange={(newColor) => onLabelColorChange(newColor)}
                    onClose={() => hideLabelPopupOnClick()}
                />
            }
            <div>
                {/* Nested DefaultSequenceVideo */}
                <Title titleControl={videoComponents.titleControl} bindControl={bindControl}/>
                <DefaultSequenceVideo
                    controls={videoComponents.controls}
                    bindControl={bindControl}
                    isNodeCollapsed={isCollapsed}
                />
            </div>
        </NodeContainer>
    );
});